import { call, put } from 'redux-saga/effects';
import ActionTypes from '../actionTypes';

type TalentFiltersAction = {
  type: string,
  filters?: {
    [filterCategory: string]: Array<string>
  }
};

export function* getAllScorecards(action): Generator<any, void, empty> {
  /**
   Body: {
    fullName: string,
    filters: []
   }
   */
  try {
    const response = yield call(() => APIService.apiRequest('GET_TALENT_SCORECARDS', 'POST', {
      body: { filters: action?.body } || {},
      query: {
        page: action?.page || 0,
        pageSize: action?.pageSize || 25,
      },
    }));

    yield put({
      type: ActionTypes.admin.getAllScorecards.SUCCESS,
      page: action?.page,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.admin.getAllScorecards.ERROR,
      error,
    });
  }
}

export function* getTalentScorecardValues(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_TALENT_SCORECARD_VALUES', 'GET', {
      routeParams: {},
    }));

    yield put({
      type: ActionTypes.admin.getTalentScorecardValues.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.admin.getTalentScorecardValues.ERROR,
      id: action?.id,
      error,
    });
  }
}

export function* getTalentScorecard(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_TALENT_SCORECARD', 'GET', {
      routeParams: {
        id: action?.id,
      },
    }));

    // get form values
    const nextRepsonse = yield call(() => APIService.apiRequest('GET_TALENT_SCORECARD_VALUES', 'GET', {
      routeParams: {},
    }));

    yield put({
      type: ActionTypes.admin.getTalentScorecardValues.SUCCESS,
      response: nextRepsonse,
    });

    yield put({
      type: ActionTypes.admin.getTalentScorecard.SUCCESS,
      id: action?.id,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.admin.getTalentScorecard.ERROR,
      id: action?.id,
      error,
    });
  }
}

export function* patchTalentScorecard(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('PATCH_TALENT_SCORECARD', 'PATCH', {
      routeParams: {
        id: action?.id,
      },
      body: action?.ops,
    }));

    yield put({
      type: ActionTypes.admin.getTalentScorecard.SUCCESS,
      page: action?.page,
      id: action?.id,
      response,
    });
    /* If we were updating talentNotes, patch the profile as well */
    if (action.ops.filter((op) => op.path === 'talentNotes').length > 0 && response?.talentNotes) {
      yield put({
        type: ActionTypes.profile.get.START,
        id: response?.profile,
      });
    }
  } catch (error) {
    yield put({
      type: ActionTypes.admin.getAllScorecards.ERROR,
      id: action?.id,
      error,
    });
  }
}

export function* talentFilters(action: TalentFiltersAction): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_TALENT_SCORECARDS', 'POST', {
      body: { filters: action?.filters },
    }));

    yield put({
      type: ActionTypes.admin.talentFilters.SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.admin.talentFilters.ERROR,
      error,
    });
  }
}
